import { toast } from "@/components/ui/notify";
import { getFriendlyErrorMessage } from "@/lib/api-client";
import type { CanvasNode, CanvasEdge } from "@opus-dt/shared-types";
import type { useReactFlow } from "reactflow";
import type { useUpdateCanvas } from "../../hooks";
import type { ValidationResult } from "../../canvas-validator";

export interface SaveHandlerParams {
  isRunning: boolean;
  validation: ValidationResult;
  draftCanvasNodes: CanvasNode[];
  draftCanvasEdges: CanvasEdge[];
  flow: ReturnType<typeof useReactFlow>;
  update: ReturnType<typeof useUpdateCanvas>;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
  onSaved?: () => void;
  onSaveOverride?: () => Promise<void>;
  onBeforeSave?: () => Promise<void>;
}

export function createCanvasSaveHandler(params: SaveHandlerParams) {
  return async function handleSave() {
    const {
      isRunning,
      validation,
      draftCanvasNodes,
      draftCanvasEdges,
      flow,
      update,
      setIsDirty,
      onSaved,
      onSaveOverride,
      onBeforeSave,
    } = params;

    if (!validation.canSave) return;
    try {
      if (onSaveOverride) {
        await onSaveOverride();
        setIsDirty(false);
        onSaved?.();
        return;
      }
      if (onBeforeSave) {
        await onBeforeSave();
      }
      await update.mutateAsync({
        nodes: draftCanvasNodes,
        edges: draftCanvasEdges,
        viewport: flow.getViewport(),
        confirmRealLine: isRunning,
      });
      toast.success("Fluxo salvo.");
      setIsDirty(false);
      onSaved?.();
    } catch (err) {
      toast.error("Falha ao salvar fluxo.", {
        description: getFriendlyErrorMessage(err, "Erro desconhecido."),
      });
    }
  };
}
